import { Grid } from '@mui/material';
import { FilterList, paramsKey } from 'src/components/filterList';
import { Header } from 'src/components/header';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { useFilterAndSorting } from 'src/hooks';
import { IFilter } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { useListUserActionsPage } from './hooks/ListUserActionsPage.hook';
import { useSbNoseWebSocket } from './hooks/useWebsocket.hook';
import { ActionTrackingGridTable } from './modules/actionTrackingGridTable/ActionTrackingGridTable';

export const ListUserActionsPage = () => {
  const { onChangeParams } = useListUserActionsPage();
  useSbNoseWebSocket();

  const filters: IFilter[] = [
    {
      label: lang.user,
      fieldType: 'filterWithSearch',
      options: [],
    },
    {
      label: lang.operation,
      options: [
        {
          label: lang.create,
          value: 'create',
        },
        {
          label: lang.update,
          value: 'update',
        },
        {
          label: lang.deleteText,
          value: 'delete',
        },
      ],
    },
    {
      label: lang.collection,
      options: [
        {
          label: lang.components,
          value: ['components', 'componentAssets'],
        },
        {
          label: lang.schedules,
          value: [
            'schedules',
            'scheduleItemOverrides',
            'scheduleItems',
            'scheduleItemBackup',
          ],
        },
        {
          label: lang.locations,
          value: [
            'locations',
            'locationGroups',
            'locationChannels',
            'scheduleAssemblies',
            'defaultAssemblies',
            'scheduleDayparts',
            'scheduleOverrides',
            'scheduleDaypartOverrides',
            'scheduleComponentBundles',
          ],
        },
        {
          label: lang.assemblies,
          value: ['assemblies', 'assemblyComponents'],
        },
        {
          label: lang.settings,
          value: ['projectConfigs', 'daypartGlobalComponents'],
        },
        {
          label: lang.products,
          value: ['products'],
        },
        {
          label: lang.productCategories,
          value: ['productCategories'],
        },
        {
          label: lang.productVariations,
          value: ['productVariations'],
        },
        {
          label: lang.bulkReplace,
          value: ['bulkReplaceRequests', 'bulkreplaceComponentSchedules'],
        },
        {
          label: lang.productVariationFlavor,
          value: ['productVariationFlavors'],
        },
        {
          label: lang.productVariationType,
          value: ['productVariationSizes'],
        },
        {
          label: lang.layouts,
          value: [
            'layouts',
            'screens',
            'sections',
            'screenSections',
            'layoutScreens',
          ],
        },
      ],
    },
    {
      label: lang.dateRange,
      fieldType: 'dateRange',
      options: [],
      dateRangeOption: {
        disableFutureDate: true,
      },
      defaultExpanded: true,
    },
    {
      label: lang.role,
      options: [
        {
          label: lang.administrator,
          value: lang.administrator,
        },
        {
          label: lang.contentCreator,
          value: lang.contentCreator,
        },
        {
          label: lang.ownerOperatorText,
          value: lang.ownerOperatorText,
        },
      ],
    },
  ];

  const { onChangeKeyword, onRemoveKeyword } = useFilterAndSorting(filters);

  const onReset = () => {
    onChangeParams('name.regexp', []);
    filters.forEach(({ label }) => {
      if (label === lang.dateRange) {
        for (const key of paramsKey(label).split('|')) {
          onChangeParams(key, []);
        }
      } else {
        onChangeParams(paramsKey(label), []);
      }
    });
  };

  const { isViewOnly } = useUserRole();

  return (
    <Grid>
      <Header
        breadcrumbItems={[
          {
            label: 'Home',
            link: '/',
          },
          {
            label: lang.actionTracking,
          },
        ]}
        title={lang.actionTracking}
        actionBar={isViewOnly && <ViewOnlyAlert />}
      />

      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <FilterList
            filters={filters}
            onChangeKeyword={onChangeKeyword}
            onRemoveKeyword={onRemoveKeyword}
            onChangeFilter={onChangeParams}
            showReset
            onReset={onReset}
            readOnly
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <ActionTrackingGridTable />
        </Grid>
      </Grid>
    </Grid>
  );
};
